import './ccf-new-window-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfNewWindowIconProps extends SvgIconProps  {}
/**
 * component used to display new window icon in interaction space
 * @param props - CcfNewWindowIconProps
 * @example - <CcfNewWindowIcon />
 * @returns SVG of new window icon
 */
export function CcfNewWindowIcon(props: CcfNewWindowIconProps) {
  return (
    <SvgIcon {...props}>
        <g id="ic_New_Window" data-name="ic_New Window" clipPath="url(#clip-ic_New_Window)">
          <g id="new-window" transform="translate(3 3)">
            <path id="Path_25296" data-name="Path 25296" d="M21.87,0h-4.2V1.4h3.22L16.48,5.81l.98.98,4.41-4.41V5.6h1.4V0Z" transform="translate(-9.27)" fill="#526b7a"/>
            <path id="Path_25297" data-name="Path 25297" d="M12.6,11.2a1.4,1.4,0,0,1-1.4,1.4H2.8a1.4,1.4,0,0,1-1.4-1.4V2.8A1.4,1.4,0,0,1,2.8,1.4H7V0H2.8A2.808,2.808,0,0,0,0,2.8v8.4A2.808,2.808,0,0,0,2.8,14h8.4A2.808,2.808,0,0,0,14,11.2V7H12.6v4.2Z" transform="translate(0 0)" fill="#526b7a"/>
          </g>
        </g>
    </SvgIcon>
  );
}

export default CcfNewWindowIcon;
